/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch} from "react-router-dom";

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss";

import Index from "components/Index.js";
import Experiment from "components/Experiment/Experiment";


ReactDOM.render(
  <BrowserRouter basename="/">
    <Switch>
      <Route path="/" exact render={props => <Index {...props} />} />
      <Route path="/version/:version/:token" exact render={props => <Experiment {...props} />} />
      <Route path="/version/:version" exact render={props => <Experiment {...props} />} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
